import { render, staticRenderFns } from "./AuthToken.vue?vue&type=template&id=2cd7487c&scoped=true&"
import script from "./AuthToken.vue?vue&type=script&lang=js&"
export * from "./AuthToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd7487c",
  null
  
)

export default component.exports